module.exports = __webpack_public_path__ + "img/z-stop.e4e18edb.png";